import React from "react";
import { cn } from "../../../shared/lib/utils.js";
import { MOBILE_TABBAR_ICON_MAP } from "../constants/mobile-tabbar-icon-map.js";
import { MOBILE_TABBAR_UI_CONFIG } from "../constants/mobile-tabbar-ui-config.js";

/**
 * @param {{
 *   tab: import("../constants/mobile-tabbar-tabs-config.js").MobileTabItem,
 *   isActive: boolean,
 *   surfaces: typeof MOBILE_TABBAR_UI_CONFIG.surfaces.solid,
 *   onPress: (tab: import("../constants/mobile-tabbar-tabs-config.js").MobileTabItem) => void,
 * }} props
 */
export function MobileTabbarItem({ tab, isActive, surfaces, onPress }) {
  const Icon = MOBILE_TABBAR_ICON_MAP[tab.icon];
  const iconTone = tab.iconTone || MOBILE_TABBAR_UI_CONFIG.defaultIconTone;

  return (
    <button
      type="button"
      onClick={() => onPress(tab)}
      className={cn(
        surfaces.item,
        isActive ? surfaces.itemActive : surfaces.itemInactive,
      )}
      aria-current={isActive ? "page" : undefined}
    >
      <span className={cn(surfaces.iconWrap, iconTone)}>
        {Icon ? <Icon className={surfaces.iconSize} /> : null}
      </span>
      <span
        className={cn(
          surfaces.label,
          isActive ? surfaces.labelActive : surfaces.labelInactive,
        )}
      >
        {tab.label}
      </span>
    </button>
  );
}
